import { j as a } from "../../jsx-runtime.BREq8dyb.js";
import { a as y, b as f, c as D, D as v, r as b, S as A, v as G, s as g, K as j, P as C } from "../../sortable.esm.jwEM6DG5.js";
import { forwardRef as q, useRef as w, useMemo as B, useCallback as P } from "react";
import { styled as p, AccordionGroup as T, Box as E, useThemeProps as I } from "@mui/joy";
function K(r, t, o) {
  const e = {
    ...r
  };
  return t.top + r.y <= o.top ? e.y = o.top - t.top : t.bottom + r.y >= o.top + o.height && (e.y = o.top + o.height - t.bottom), t.left + r.x <= o.left ? e.x = o.left - t.left : t.right + r.x >= o.left + o.width && (e.x = o.left + o.width - t.right), e;
}
const N = (r) => {
  let {
    containerNodeRect: t,
    draggingNodeRect: o,
    transform: e
  } = r;
  return !o || !t ? e : K(e, o, t);
}, R = (r) => {
  let {
    transform: t
  } = r;
  return {
    ...t,
    x: 0
  };
}, l = "DqSortableAccordionGroup", M = p(T, {
  name: l,
  slot: "root"
})(), O = p(E, {
  name: l,
  slot: "boundingRect"
})({
  height: "100%",
  left: 0,
  position: "absolute",
  top: 0,
  visibility: "hidden",
  width: "100%",
  zIndex: -1
});
function k(r, t) {
  const {
    children: o,
    ids: e,
    onIdsSort: c,
    ...u
  } = I({
    name: l,
    props: r
  }), d = w(null), x = ({
    droppableContainers: s,
    ...i
  }) => b({
    ...i,
    /**
     * NOTE: For large containers (e.g. expanded accordion) comparing with itself will always yield
     * a bigger overlap area than the overlap with other containers, thus the active container should
     * be excluded from the list of droppable containers.
     */
    droppableContainers: s.filter(({
      id: n
    }) => n !== i.active.id)
  }), h = y(f(C), f(j, {
    coordinateGetter: g
  })), m = B(() => [R, (s) => N({
    ...s,
    containerNodeRect: d?.current?.getBoundingClientRect() || null
  })], []), S = P((s) => {
    const {
      active: i,
      over: n
    } = s;
    n && i.id !== n.id && c(D(e, e.indexOf(i.id), e.indexOf(n.id)));
  }, [e, c]);
  return /* @__PURE__ */ a.jsx(M, { ref: t, ...u, children: /* @__PURE__ */ a.jsx(v, { collisionDetection: x, modifiers: m, onDragEnd: S, sensors: h, children: /* @__PURE__ */ a.jsxs(A, { items: e, strategy: G, children: [
    o,
    /* @__PURE__ */ a.jsx(O, { ref: d })
  ] }) }) });
}
const W = q(k);
export {
  W as default
};
//# sourceMappingURL=DqSortableAccordionGroup.js.map
